import { useState } from 'react'

import Button from '../app/design/Button'
import Modal from '../app/design/Modal'
import { AddressPicker } from '../common/AddressPicker'
import { WorkflowPage } from '../workflows/WorkflowPage'

type Props = {
    onClose: () => void
    onDone: (location: string) => void
    currentLocation?: string
    filterAddresses?: boolean
}

export const LocationModal = ({ onClose, onDone, currentLocation, filterAddresses }: Props) => {
    const [selectedAddress, setSelectedAddress] = useState(currentLocation ?? '')

    return (
        <Modal
            isOpen={true}
            onClose={onClose}
            title="Location"
            footer={
                <div className="flex w-full items-center justify-end gap-x-4">
                    <Button
                        intent="primary"
                        onClick={() => {
                            if (selectedAddress) {
                                onDone(selectedAddress)
                            }
                        }}
                        disabled={!selectedAddress}
                    >
                        Save
                    </Button>
                </div>
            }
        >
            <div className="flex flex-col gap-1">
                <WorkflowPage.IconSection icon="markerPin.large" title="Your business location">
                    <AddressPicker
                        size="medium"
                        defaultAddress={selectedAddress}
                        onSelect={setSelectedAddress}
                    />
                </WorkflowPage.IconSection>
            </div>
        </Modal>
    )
}
